
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import CreateFeedback from "./pages/CreateFeedback";
import ViewFeedback from "./pages/ViewFeedback";
import Feedback from "./pages/Feedback";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import RequestFeedback from "./pages/RequestFeedback";
import ProjectDetail from "./pages/ProjectDetail";
import ProtectedRoute from "./components/ProtectedRoute";
import Admin from "./pages/Admin";
import Unauthorized from "./pages/Unauthorized";
import RequestFeedbackUnified from "./pages/RequestFeedbackUnified";
import RequestCollectiveFeedback from "./pages/RequestCollectiveFeedback";
import OrganizationProfile from "./pages/OrganizationProfile";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      
      {/* Protected routes */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/create-feedback" 
        element={
          <ProtectedRoute>
            <CreateFeedback />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/request-feedback" 
        element={
          <ProtectedRoute>
            <RequestFeedback />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/request-feedback-unified" 
        element={
          <ProtectedRoute>
            <RequestFeedbackUnified />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/request-collective-feedback" 
        element={
          <ProtectedRoute>
            <RequestCollectiveFeedback />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/profile" 
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/organization" 
        element={
          <ProtectedRoute>
            <OrganizationProfile />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/project/:id" 
        element={
          <ProtectedRoute>
            <ProjectDetail />
          </ProtectedRoute>
        } 
      />

      {/* Admin routes */}
      <Route 
        path="/admin/*" 
        element={
          <ProtectedRoute adminOnly>
            <Admin />
          </ProtectedRoute>
        } 
      />
      
      {/* Public routes */}
      <Route path="/feedback" element={<Feedback />} />
      <Route path="/view-feedback/:id" element={<ViewFeedback />} />
      
      {/* Redirects */}
      <Route path="/home" element={<Navigate to="/" replace />} />
      
      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
